export default __webpack_public_path__ + "static/media/plusicon.09305335.svg";